import React, { Component } from 'react'
import './AboutUs.css'
let aboutUs = 'Details not available'
class AboutUs extends Component {
    constructor(props) {
        super(props)
    }
    componentWillReceiveProps(nextProps){
        aboutUs=nextProps.transporter_data.about_us;
        if(aboutUs==undefined || aboutUs==null){
            aboutUs='Details not available'
    
        }
    }
    
    render() {

        return (
            <>
                <div className="aucard">
                    <div className="aucontainer row">
                        <div className="col-12">
                            <h3 className="data_header">Market Intelligence</h3>
                        </div>
                        <div className="col-12">
                            <p>{
                                aboutUs
                            }</p>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default AboutUs
